import { jobsActions, jobsSelectors, useAppDispatch } from '@readcloud/state';
import React from 'react';
import { useSelector } from 'react-redux';
import { ToastGenerator } from './ToastGenerator';

type Props = {};

export const ConnectedToastGenerator: React.FC<Props> = (props: Props) => {
  const jobs = useSelector(jobsSelectors.getJobs);
  const dispatch = useAppDispatch();

  const onClose = (jobId: string) => dispatch(jobsActions.deleteJob(jobId));

  return <ToastGenerator onClose={onClose} jobs={jobs} />;
};
